import type { FunctionalComponent } from 'preact';
import { BRAND_NAME, BUSINESS_HREF, FOOTER_LINKS } from '@/data/site.ts';

/**
 * 시안(`_login.html`, `_info.html`)의 공통 푸터.
 * 브랜드 링크 + 이용약관 한 줄 구성이다.
 */
export const Footer: FunctionalComponent = () => (
  <footer>
    <a href={BUSINESS_HREF} class="footer-brand">
      {BRAND_NAME}
      <span>
        <img src="/images/arrow-right.png" alt="" />
      </span>
    </a>
    <div class="footer-link-wrap">
      {FOOTER_LINKS.map((link) => (
        <a key={link.href} href={link.href} class="footer-link">
          {link.label}
        </a>
      ))}
    </div>
  </footer>
);
